"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useSetupUserProvider = require("./useSetupUserProvider");
Object.keys(_useSetupUserProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useSetupUserProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useSetupUserProvider[key];
    }
  });
});
